/**
 * THIS PERSON'S RECENT REACTIONS, for the picker's Frequently Used row — a per-viewer convenience kept in
 * this browser only (it never needs to reach anyone else, and losing it costs nothing but the order of
 * one row). Every read and write survives a storage that throws: a private window, blocked site data.
 */
const KEY = 'avg_rx_recent'
const KEEP = 14

export function readRecent(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string').slice(0, KEEP) : []
  } catch {
    return []
  }
}

export function rememberPick(emoji: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([emoji, ...readRecent().filter((e) => e !== emoji)].slice(0, KEEP)))
  } catch {
    /* No storage here: the row falls back to the common ones. */
  }
}
